export enum IssuerType {
  Company,
  Municipal,
}
